import axios from 'axios'
const api = "configurar"

const cedisCatalogoDiferente = {
    getCedis: () => axios.get(`${api}/get-cedis-catalogo`),
    putCedisCatalogo: (cedi,params) => axios.put(`${api}/${cedi}/set-cedis-catalogo`,params)
}
export default cedisCatalogoDiferente